import { replace, truncate } from "lodash/fp";

import {
  MeetingPlatform,
  UnauthorizedVideoRecording,
  VideoRecording,
} from "@app/common/types";

export const getVideoRecordingDownloadUrl = (
  videoRecording: VideoRecording | UnauthorizedVideoRecording | undefined,
  { recordingsUrl, filename }: { recordingsUrl: string; filename: string }
) => {
  if (!videoRecording || videoRecording.status === "unauthorized") return "";

  return `${recordingsUrl}/packaged/${videoRecording.sessionId}/${
    videoRecording.id
  }/stream_0/vod.mp4?recording_access_token=${encodeURIComponent(
    videoRecording.recordingAccessToken
  )}&video_name=${encodeURIComponent(filename)}`;
};

export const getVideoDownloadUrl = (url: string, filename: string) => {
  return `${url}&video_name=${encodeURIComponent(filename)}`;
};

export const getDownloadTitle = (
  title: string | null,
  name: string,
  defaultTitle = "Meeting"
) =>
  replace(
    /\./g,
    "_",
    title
      ? `${truncate({ length: 40, omission: "_" }, title)} ${name}`
      : `${defaultTitle} ${name}`
  );

export const getDataHref = (fileData: string) => `data:text/plain,${fileData}`;

export const getDownloadOptsForClient = ({
  client,
  externalDownloadHref,
  data,
  fileName,
}: {
  client: MeetingPlatform;
  externalDownloadHref: string;
  data: string;
  fileName: string;
}): { href: string; download?: string } => {
  if (client === "zoom") {
    return { href: externalDownloadHref };
  }

  return { href: getDataHref(data), download: fileName };
};
